import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiEye, FiTarget, FiShield, FiZap, FiHeart, FiUsers } = FiIcons;

const Services = () => {
  const services = [
    {
      icon: FiEye,
      title: 'Comprehensive Eye Tests',
      description: 'Complete vision screening including refraction, color blindness, and pressure testing',
      features: ['Digital Retinal Imaging', 'Glaucoma Screening', 'Diabetic Eye Checks']
    },
    {
      icon: FiTarget,
      title: 'Contact Lens Fitting',
      description: 'Professional fitting and training for all types of contact lenses',
      features: ['Daily Disposables', 'Monthly Lenses', 'Specialized Lenses']
    },
    {
      icon: FiShield,
      title: 'Frame Selection',
      description: 'Expert guidance in choosing the perfect frames for your face shape and lifestyle',
      features: ['Face Shape Analysis', 'Lifestyle Consultation', 'Style Matching']
    },
    {
      icon: FiZap,
      title: 'Quick Repairs',
      description: 'Fast and reliable repair services for damaged spectacles',
      features: ['Same Day Service', 'Frame Adjustments', 'Lens Replacement']
    },
    {
      icon: FiHeart,
      title: 'Children\'s Eye Care',
      description: 'Specialized eye care services designed specifically for children',
      features: ['School Screenings', 'Myopia Control', 'Kid-Friendly Frames']
    },
    {
      icon: FiUsers,
      title: 'Corporate Packages',
      description: 'Bulk eye testing services for businesses and organizations',
      features: ['On-site Testing', 'Group Discounts', 'Health Reports']
    }
  ];

  return (
    <section id="services" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our <span className="gradient-text">Services</span>
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Comprehensive eye care solutions with state-of-the-art technology and personalized attention
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              className="glass-card p-8 group hover:shadow-2xl transition-all duration-300"
            >
              <div className="glass-icon mb-6 group-hover:scale-110 transition-transform duration-300">
                <SafeIcon icon={service.icon} className="text-3xl text-blue-400" />
              </div>

              <h3 className="text-2xl font-bold text-white mb-4">
                {service.title}
              </h3>

              <p className="text-white/70 mb-6 leading-relaxed">
                {service.description}
              </p>

              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="text-white/60 text-sm flex items-center">
                    <div className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3"></div>
                    {feature}
                  </li>
                ))}
              </ul>

              <motion.div
                whileHover={{ scale: 1.05 }}
                className="mt-8"
              >
                <button className="glass-button w-full py-3 text-white font-medium">
                  Learn More
                </button>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;